/**                          🐢
 *  🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴
 * 🔴                                                                    🐛🔴
 * 🔴     🚨 ⛔️ POZOR - string hodnoty klíčů se nesmí měnit!  ⛔️ 🚨       🔴
 * 🔴                                                                      🔴
 *  🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🥷🏻
 *  Pokud by se změnily, uživatel by přišel o uložené nastavení k filtrům, sloupcům apod. (v db serveru by to zůstalo, ale protože se změní klíč tak by se mu to nezobrazovalo). 🌱
 */
export const DAVKY_DTM_SETTINGS_KEY = 'davky-dtm';
export const DTM_ZARIZENI_SETTINGS_KEY = 'dtm-zarizeni';
export const ATTRIBUTE_TABLE_SETTINGS_KEY = 'attribute-table';
